import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PostCard from '../components/PostCard';
import './Home.css';

const FEATURES = [
  {
    color: 'var(--brick)',
    icon: '✦',
    title: 'One email, no noise',
    body: 'A friendly round-up of what\'s happening nearby — and the odd heads-up when it matters.',
  },
  {
    color: 'var(--olive)',
    icon: '◆',
    title: 'Events on your doorstep',
    body: 'Clean-ups, the spring festival, the AGM and more. Small things that make a street feel like home.',
  },
  {
    color: 'var(--ochre)',
    icon: '●',
    title: 'A voice with the council',
    body: 'We represent residents on traffic, planning and the things that affect our neighbourhood.',
  },
];

const Home = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let mounted = true;
    fetch('/api/news')
      .then(r => r.ok ? r.json() : [])
      .then(data => { if (mounted) setPosts(Array.isArray(data) ? data.slice(0, 3) : []); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  return (
    <div className="home">

      {/* ── Hero ──────────────────────────────────────────────── */}
      <section className="hero-section wrap">
        <div className="hero-grid">
          <div className="hero-text">
            <span className="hero-eyebrow">
              <span className="badge olive"><span className="badge-dot"></span>Active</span>
              Serving the Carlisle &amp; Waverley neighbourhood
            </span>
            <h1>
              The friendly corner of{' '}
              <span className="hl">Carlisle&nbsp;&amp;&nbsp;Waverley</span>.
            </h1>
            <p className="lead" style={{ maxWidth: 520 }}>
              CWARA is a volunteer-run residents association keeping our patch friendly,
              safe and well-connected. What's on, what's changing, and how to get
              involved — all in one place.
            </p>
            <div className="hero-actions row">
              <Link to="/join" className="btn btn-primary btn-lg">Join CWARA — it's free</Link>
              <Link to="/noticeboard" className="btn btn-ghost btn-lg">See the noticeboard</Link>
            </div>
          </div>

          <div className="hero-map">
            <Link to="/map" className="map-preview" aria-label="Open the CWARA area map">
              <iframe
                src={`${process.env.PUBLIC_URL}/area-map/index.html`}
                title="CWARA area map preview"
                loading="lazy"
                tabIndex={-1}
              />
              <span className="map-preview-overlay">
                <span className="map-preview-btn">Open full map &rarr;</span>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* ── Feature band ──────────────────────────────────────── */}
      <section className="band">
        <div className="wrap feature-grid">
          {FEATURES.map(({ color, icon, title, body }) => (
            <div className="feature card" key={title}>
              <div className="ficon" style={{ background: color }}>{icon}</div>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Latest noticeboard ────────────────────────────────── */}
      {posts.length > 0 && (
        <section className="section wrap">
          <div className="board-toolbar">
            <div className="sec-head">
              <span className="kicker">From the noticeboard</span>
              <h2>The latest, pinned up</h2>
              <p className="lead" style={{ maxWidth: 520 }}>
                A peek at what's going on around the area right now.
              </p>
            </div>
            <Link to="/noticeboard" className="btn btn-outline">See everything</Link>
          </div>
          <div className="board-grid">
            {posts.map((p, i) => <PostCard key={p.id || i} post={p} index={i} />)}
          </div>
        </section>
      )}

      {/* ── CTA strip ─────────────────────────────────────────── */}
      <section className="wrap" style={{ paddingBottom: 72 }}>
        <div className="cta-strip">
          <span className="kicker" style={{ color: 'rgba(255,255,255,0.85)', justifyContent: 'center' }}>
            Live in the area?
          </span>
          <h2>It's your association — come and join us.</h2>
          <p>Free if you live within the boundary. Pop in your postcode and we'll do the rest.</p>
          <Link to="/join" className="btn btn-light btn-lg">Check my postcode</Link>
        </div>
      </section>

    </div>
  );
};

export default Home;
